import { Store } from 'src/store/index';

const getProductBundleSelectedProductsTotalPrice = (store: Store) => store.productBundle.selectedProductsTotalPrice;

export default getProductBundleSelectedProductsTotalPrice;
